import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENVIRONMENT_CONFIG } from '@ipreo/northstar';

enum ENV {
  'qx' = 'QX',
  'demo' = 'UAT',
  'uat' = 'UAT',
  'prod' = 'PROD'
}

@Injectable()
export class DealDocumentsService {
  public muniApiHost: string;
  public muniEnv: string;
  constructor(@Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig) {
    this.muniApiHost = config.params['muniApiHost'] as string;
    this.muniEnv = (config.params['env'] ||
      config.params['buySideEnv']) as string;
  }

  public documentUrl(id: string): string {
    if (!this.muniApiHost) {
      throw new Error('Environment variable "muniApiHost" is not set');
    }

    if (!this.muniEnv) {
      throw new Error('Environment variable "env" or "buySideEnv" is not set');
    }
    const env_prefix = ENV[this.muniEnv];

    return `${this.muniApiHost}/documents/${env_prefix}::${id}`;
  }
}
